import React, { cloneElement, useContext } from 'react';
import { ExportButton, TopToolbar, useNotify } from 'react-admin';
import { ImportButton } from 'react-admin-import-csv';
import {
  Breadcrumbs,
  Link,
  Typography,
  Grid,
  makeStyles,
  Button
} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import AddIcon from '@material-ui/icons/Add';
import { QuickAppointmentContext } from '../Context';
const useStyles = makeStyles(() => ({
  topbarHeader: {
    marginBottom: '8px',
  },
  exportBtn: {
    color: '212B36',
    fontWeight: '500'
  }
}));

const ListActions = (props) => {
  const {
    className,
    basePath,
    total,
    resource,
    currentSort,
    filters,
    filterValues,
    exporter,
    showImportButton,
    showBreadcrumbs,
    showAddButton,
    addbuttontitle,
    currentbreadcrumb,
    prevbreadcrumb
  } = props;
  const notify = useNotify();
  const classes = useStyles();
  const alertImportErrors = (reportItems) => {
    const numErrors = reportItems.filter((r) => !r.success).length;
    const numSuccess = reportItems.filter((r) => r.success).length;

    if (numErrors > 0) {
      const errors = reportItems
        .filter((r) => !r.success)
        .map((r) => `"${r.err.message || 'Unknown Error'}"`);
      const distinctErrors = [...new Set(errors)];
      const plural = distinctErrors.length !== 1 ? 's' : '';

      const fullErrorMsg = `Succeeded: ${numSuccess}. Failed: ${numErrors}. Error message${plural}: ${distinctErrors.join(
        ', ',
      )}`;

      notify(fullErrorMsg, 'error');
    } else {
      const plural = numSuccess !== 1 ? 's' : '';
      notify(`Successfully imported ${numSuccess} item${plural}.`);
    }
  };

  const { handleOpen: handleAppointmentOpen } = useContext(
    QuickAppointmentContext,
  );
  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/">
      Dashboard
    </Link>,
    <Link
      underline="none"
      key="2"
      color="inherit"
    >
      {prevbreadcrumb}
    </Link>,
    <Typography key="3" color="text.primary" className="active">
      {currentbreadcrumb}
    </Typography>,
  ];
  function handleClick(event) {
    event.preventDefault();
  }

  return (
    <TopToolbar className={`topbar ${className}`}>

      <Grid container direction="row" className="topbar" spacing={0}>
        <Grid container item xs={12} className={classes.topbarHeader} alignItems="center">
          {(showBreadcrumbs) && (
            <Grid container item xs={12} sm={6} md={9}>
              <div>
                <Typography variant="h3">{currentbreadcrumb}</Typography>
                <Breadcrumbs separator={<FiberManualRecordIcon className="breadcrumb_icon" fontSize="inherit" />} aria-label="breadcrumb">
                  {breadcrumbs}
                </Breadcrumbs>
              </div>
            </Grid>
          )}
          <Grid container item xs={12} sm={6} md={3} className="topbar_actions">
            {showAddButton && (
              <Button className="add_btn" startIcon={<AddIcon />} onClick={handleAppointmentOpen}>
                {addbuttontitle}
              </Button>
            )}
            {filters && cloneElement(filters, { context: 'button' })}
            <ExportButton
              disabled={total === 0}
              resource={resource}
              sort={currentSort}
              filter={filterValues}
              icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M9.375 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V9.375M2.25 7.5H15.75M7.5 2.25V15.75M12 14.25H16.5M16.5 14.25L14.25 12M16.5 14.25L14.25 16.5" stroke="#637381" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>}
              exporter={exporter}
              className={classes.exportBtn}
            />
            {showImportButton && (
              <ImportButton
                {...props}
                logging
                disableImportNew={false}
                disableImportOverwrite={false}
                postCommitCallback={alertImportErrors}
              />
            )}
          </Grid>
        </Grid>
      </Grid>


    </TopToolbar>
  );
};

export default ListActions;
